import { render, staticRenderFns } from "./StatsWithNarrative.vue?vue&type=template&id=312f81ca&scoped=true&"
import script from "./StatsWithNarrative.vue?vue&type=script&lang=js&"
export * from "./StatsWithNarrative.vue?vue&type=script&lang=js&"
import style0 from "./StatsWithNarrative.vue?vue&type=style&index=0&id=312f81ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312f81ca",
  null
  
)

export default component.exports